import { type PurchasePaymentChannel } from '@setplex/tria-api'

export const NoPaymentChannel = {
  paymentChannel: 'NO_PAYMENT_CHANNEL',
  environment: '',
}

export type PaymentChannel = PurchasePaymentChannel | typeof NoPaymentChannel
